<template>
  <ResetPasswordModal
    :title="title"
    subTitle="We will send you a reset link"
    @close="$emit('close')"
    :show="true"
    :showBackButton="showBackButton"
    :bgChange="true"
  >
    <template v-slot:content>
      <section class="reset-password">
        <form @submit.prevent="validateForm = true" class="reset-password__form">
          <div class="reset-password__header">
            <div class="reset-password__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 6L12 13L2 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h2 class="reset-password__title">Enter your email</h2>
            <p class="reset-password__desc">We will send a password reset link to your email address</p>
          </div>
          <div class="reset-password__form-group">
            <label class="reset-password__label">Email Address</label>
            <InputField
              label="Enter email address"
              type="email"
              name="email"
              :currentValue="email"
              @input-changed="storeValue"
              @is-valid="handleValidation"
              :validate="validateForm"
            />
          </div>
          <CustomButton title="Send Reset Link" :loading="loading" />
        </form>
      </section>
    </template>
  </ResetPasswordModal>
</template>

<script>
import CustomButton from "@/components/onboarding/OnboardingBtn";
import { mapActions, mapGetters } from "vuex";
import InputField from "../general/InputField";
import ResetPasswordModal from "@/components/general/sidemodal/SideModal";
import { emailUrl } from "@/utils/helpers";

export default {
  name: "ResetPassword",
  data() {
    return {
      loading: false,
      title: "Reset Password",
      showBackButton: false,
      email: "",
      validateForm: false,
      validationResult: [],
    };
  },
  components: {
    CustomButton,
    InputField,
    ResetPasswordModal,
  },
  computed: {
    ...mapGetters("organisationModule", ["organisationDetails"]),
  },
  emits: ["close"],
  watch: {
    validateForm(val) {
      if (!val) {
        setTimeout(() => {
          this.validateForm = false;
        }, 1000);
      }
    },
    validationResult: {
      deep: true,
      handler(val) {
        if (val.length === 1 && !val.includes(false)) {
          this.sendResetPin();
        }
      },
    },
  },
  methods: {
    ...mapActions("organisationModule", ["login", "resetPasswordLink"]),
    ...mapActions(["showToast"]),
    emailUrl,
    storeValue(object) {
      this[object.name] = object.value;
    },
    handleValidation(value) {
      this.validationResult.push(value);
    },
    async sendResetPin() {
      this.loading = true;
      const url = `${this.emailUrl()}/new-password`;
      try {
        const response = await this.resetPasswordLink({
          email: this.email,
          mail_base_url: url,
        });
        this.loading = false;
        const { message } = response.data;
        this.showToast({
          description: message,
          display: true,
          type: "success",
        });
        this.$emit("close");
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-password {
  padding: 0 24px 24px;

  &__form {
    max-width: 320px;
    margin: 0 auto;
  }

  &__header {
    text-align: center;
    margin-bottom: 32px;
  }

  &__icon {
    width: 56px;
    height: 56px;
    background: #F1F5F9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: #64748B;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 8px 0;
  }

  &__desc {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
    line-height: 1.5;
  }

  &__form-group {
    margin-bottom: 24px;
  }

  &__label {
    display: block;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
    margin-bottom: 8px;
  }
}
</style>
